import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CartService } from '../../../core/services/cart.service';

@Component({
  selector: 'app-block-header',
  imports: [
    RouterLink
  ],
  templateUrl: './header.html',
  standalone: true,
  styleUrl: './header.scss'
})
export class HeaderBlock {
  readonly cartService = inject(CartService);
}
